import React, { useState } from 'react';
import axios from 'axios';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonPage,
  IonButtons,
  IonMenuButton,
  IonRow,
  IonCol,
  IonButton,
  IonList,
  IonItem,
  IonInput,
  IonText,
} from '@ionic/react';
import './Login.scss';
import { setIsLoggedIn, setUsername } from '../data/user/user.actions';
import { connect } from '../data/connect';
import { RouteComponentProps } from 'react-router';

interface OwnProps extends RouteComponentProps {}

interface DispatchProps {
  setIsLoggedIn: typeof setIsLoggedIn;
  setUsername: typeof setUsername;
}

interface LoginProps extends OwnProps, DispatchProps {}

const Login: React.FC<LoginProps> = ({
  setIsLoggedIn,
  history,
  setUsername: setUsernameAction,
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loginError, setLoginError] = useState('');

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const login = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!email || !validateEmail(email)) {
      setEmailError(true);
      return;
    }
    if (!password) {
      setPasswordError(true);
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    
    if (email && password ) {
      try {
        const response = await axios.post(`${apiUrl}/login`, {
          email: email,
          password: password,
        });

        if (response.status === 200) {
          const token = response.data.data.token;
          localStorage.setItem('authToken', token);
          await setIsLoggedIn(true);
          await setUsernameAction(response.data.data.name);
          history.push('/tabs/store', { direction: 'none' });
        }
      } catch (error) {
        console.error('Error during registration:', error);
        setLoginError('メールアドレスまたはパスワードが正しくありません。');
      }
    }
  };

  return (
    <IonPage id="login-page">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>ログイン</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="login-logo">
          <img src="assets/icon/favicon.png" alt="Ionic logo" />
        </div>
        {loginError && (
          <IonText color="danger" className="center-text">
            <p>{loginError}</p>
          </IonText>
        )}
        <form noValidate onSubmit={login}>
          <IonList>
            <IonItem>
              <IonInput
                label="メールアドレス"
                labelPlacement="stacked"
                color="primary"
                name="email"
                type="text"
                value={email}
                spellCheck={false}
                autocapitalize="off"
                onIonInput={(e) => setEmail(e.detail.value as string)}
                required
              >
                {formSubmitted && emailError && (
                  <IonText color="danger" slot="error">
                    <p>メールアドレスを正確に入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>

            <IonItem>
              <IonInput
                label="パスワード"
                labelPlacement="stacked"
                color="primary"
                name="password"
                type="password"
                value={password}
                onIonInput={(e) => setPassword(e.detail.value as string)}
              >
                {formSubmitted && passwordError && (
                  <IonText color="danger" slot="error">
                    <p>パスワードを入力してください。</p>
                  </IonText>
                )}
              </IonInput>
            </IonItem>
          </IonList>
          <IonRow>
            <IonCol>
              <IonButton type="submit" expand="block">
                ログイン
              </IonButton>
            </IonCol>
            <IonCol>
              <IonButton routerLink="/signup" color="light" expand="block">
                登　録
              </IonButton>
            </IonCol>
          </IonRow>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default connect<OwnProps, {}, DispatchProps>({
  mapDispatchToProps: {
    setIsLoggedIn,
    setUsername,
  },
  component: Login,
});
